// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1y6ZF","inputWrap":"CustomTip_inputWrap__2yOfZ"};